// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2cVmI","title":"ClientInsurance_title__1JuxM","itemText":"ClientInsurance_itemText__2jaXh"};